import React from 'react';
import { locationData } from '../../data/mock';
import { MapPin } from 'lucide-react';

const Location = () => {
  return (
    <section id="location" className="section-padding bg-[#E8EFEC]">
      <div className="container-custom">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <div>
            <h2 className="font-display text-3xl md:text-4xl font-normal text-[#1E2E2A] mb-8 tracking-wider">
              {locationData.title}
            </h2>
            
            <p className="text-lg text-[#1E2E2A]/70 leading-relaxed mb-6">
              {locationData.copy}
            </p>

            {locationData.smallLine && (
              <p className="text-sm text-[#5C7A6E] flex items-center gap-2">
                <MapPin className="w-4 h-4" />
                {locationData.smallLine}
              </p>
            )}
          </div>

          <div className="relative">
            <div className="rounded-2xl overflow-hidden shadow-xl">
              <img
                src={locationData.image}
                alt="Golden Triangle location"
                className="w-full h-[350px] object-cover"
              />
            </div>
            <div className="absolute -z-10 -bottom-4 -right-4 w-full h-full bg-[#3E6259]/10 rounded-2xl" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Location;
